import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';
import Hero from './components/Hero';
import Stats from './components/Stats';
import ValueProp from './components/ValueProp';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Integrations from './components/Integrations';
import ComplianceManagement from './components/ComplianceManagement';
import WhyCaptiveWorks from './components/WhyCaptiveWorks';
import BuiltFor from './components/BuiltFor';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import ScheduleCall from './components/ScheduleCall';
import './styles/App.css';

function HomePage() {
  return (
    <>
      <Hero />
      <Stats />
      <ValueProp />
      <HowItWorks />
      <ComplianceManagement />
      <Features />
      <Integrations />
      <WhyCaptiveWorks />
      <BuiltFor />
      <FAQ />
      <FinalCTA />
      <Footer />
    </>
  );
}

function AnalyticsListener() {
  const location = useLocation();
  const isFirstRoute = useRef(true);

  useEffect(() => {
    const path = location.pathname + location.search;
    // Initial page view is sent by gtag config (send_page_view: true); avoid double count
    if (isFirstRoute.current) {
      isFirstRoute.current = false;
      return;
    }
    trackPageView(path);
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <Router>
      <AnalyticsListener />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/schedule-call" element={<ScheduleCall />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
